import { render, staticRenderFns } from "./GiftDialog.vue?vue&type=template&id=7aa00eb7&scoped=true"
import script from "./GiftDialog.vue?vue&type=script&lang=js"
export * from "./GiftDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa00eb7",
  null
  
)

export default component.exports